import { PropertyPortal } from 'src/api/generated';
import type { SupportedProviderBrandId } from 'src/modules/shared/components/molecules/provider-brand-avatar';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';

export type SupportedPropertySourceProviderId = Exclude<
  SupportedProviderBrandId,
  'whatsapp'
>;

/**
 * Maps a property source system to a known integration provider identifier.
 */
export const resolvePropertySourceProviderId = (
  sourceSystem?: string | null
): SupportedPropertySourceProviderId | null => {
  if (!sourceSystem) {
    return null;
  }

  switch (sourceSystem.trim().toLowerCase()) {
    case 'meli':
      return 'meli';
    case '2clics':
      return '2clics';
    case 'wasi':
      return 'wasi';
    case 'toppropiedades':
      return 'toppropiedades';
    case 'kiteprop':
      return 'kiteprop';
    default:
      return null;
  }
};

/**
 * Maps a publication portal to the owning integration provider identifier.
 */
export const resolvePublicationPortalProviderId = (
  portal?: PropertyPortal | null
): SupportedPropertySourceProviderId | null => {
  if (!portal) {
    return null;
  }

  switch (portal) {
    case PropertyPortal.MELI:
      return 'meli';
    case PropertyPortal.TOCTOC:
    case PropertyPortal.PROPPIT:
    case PropertyPortal.YAPO:
      return null;
  }
};

/**
 * Returns the translation key for a known integration provider label.
 */
export const getPropertySourceProviderLabelKey = (
  providerId: SupportedPropertySourceProviderId
): TranslationKey => {
  switch (providerId) {
    case 'meli':
      return 'settings.integrations.meli.title';
    case '2clics':
      return 'settings.integrations.2clics.title';
    case 'wasi':
      return 'settings.integrations.wasi.title';
    case 'toppropiedades':
      return 'settings.integrations.toppropiedades.title';
    case 'kiteprop':
      return 'settings.integrations.kiteprop.title';
  }
};
